import { render, staticRenderFns } from "./SmartDispenser.vue?vue&type=template&id=610dd508&scoped=true"
import script from "./SmartDispenser.vue?vue&type=script&lang=js"
export * from "./SmartDispenser.vue?vue&type=script&lang=js"
import style0 from "./SmartDispenser.vue?vue&type=style&index=0&id=610dd508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610dd508",
  null
  
)

export default component.exports